var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit"},[_c('h5',[_vm._v("Confirm password?")]),_c('div',[_c('button',{staticClass:"no",on:{"click":_vm.noClick}},[_vm._v("NO")]),_c('button',{staticClass:"yes",on:{"click":_vm.yesClick}},[_vm._v("YES")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }